


<app-system-message></app-system-message>

<!-- Container for the form with dynamic styling -->
<div [ngClass]="theme.getThemeClass()" class="container-fluido">

    <div [ngClass]="theme.getThemeClass()" class="card bg-light">
        <article class="card-body mx-auto article">
            <h4 class="card-title mt-0 text-center">{{ 'createWorkOrder' | translate }}</h4>
            <form>
                <!-- DEVICE LIST/THING NAMES SELECT INPUT -->
              <div>
                @if (showOnlyThingName) {
                <label class="label-spacer">{{ 'logsApiTableHeaderDevice' | translate }}</label>
                }
                @if (showOnlyThingName) {
                <label class="only-label-display">{{ this.thing_name }}</label>
                }
                @if (!showOnlyThingName) {
                <label class="label-spacer">{{ 'selectDevice' | translate }}<span class="requiredStar"> *</span></label>
                }
                @if (!showOnlyThingName) {
                <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon1"><i class="fas fa-angle-double-right"></i></span>
                    <select
                      #thing_select
                      class="form-control"
                      name="thing"
                      [(ngModel)]="this.workOrderService.workOrderData.thing_name"
                      (change)="selectedThingChange($event)"
                      [ngClass]="{ 'has-value': this.workOrderService.workOrderData.thing_name }"
                      [disabled]="isThingSelectDisabled"
                    >
                      <option value="">{{ 'selectDevice' | translate }}</option>
                      @for (thing of things; track thing.thing_name) {
                        <option [value]="thing.thing_name">{{ thing.thing_name }}</option>
                      }
                    </select>
                </div>
                }
              </div>


                <!-- CLIENT LIST/ID SELECT INPUT -->
                @if (!hideClient && this.cognitoService.userType !== 'client') {
                <div>
                  @if (showOnlyClientLabel) {
                  <label class="label-spacer">{{ '_client' | translate }}</label>
                  }
                  @if (showOnlyClientLabel) {
                  <label class="only-label-display">{{ this.clientData.legal_name }}</label>
                  }
                  @if (!showOnlyClientLabel) {
                  <label class="label-spacer">{{ 'clientName' | translate }}</label>
                  }
                  @if (!showOnlyClientLabel) {
                  <div class="input-group mb-3">
                      <span class="input-group-text" id="basic-addon1"><i class="fas fa-briefcase"></i></span>
                      <select
                        #client_select
                        class="form-control"
                        name="client"
                        [(ngModel)]="this.workOrderService.workOrderData.client_id"
                        (change)="selectedClientChange($event)"
                        [ngClass]="{ 'has-value': this.workOrderService.workOrderData.client_id }"
                        [disabled]="isClientSelectDisabled"
                      >
                        <option value="">{{ 'clientName' | translate }}</option>
                        @for (client of clientArray; track client.client_id) {
                          <option [value]="client.client_id">{{ client.client_name }}</option>
                        }
                      </select>
                  </div>
                }
                </div>
                }

                <!-- BINS ID LIST SELECT INPUT -->
                @if (!hideBin) {
                <div>
                  @if (showOnlyBinLabel) {
                  <label class="label-spacer">{{ 'adminViewBinListNavBar' | translate }}</label>
                  }
                  @if (showOnlyBinLabel) {
                  <label class="only-label-display">{{ this.binData.bin_name }}</label>
                  }
                  @if (!showOnlyBinLabel) {
                  <label class="label-spacer">{{ 'selectBinId' | translate }}</label>
                  }
                  @if (!showOnlyBinLabel) {
                  <div class="input-group mb-3">
                      <span class="input-group-text" id="basic-addon1"><i class="fab fa-artstation"></i></span>
                      <select
                        #bin_select
                        class="form-control"
                        name="bin"
                        [(ngModel)]="this.workOrderService.workOrderData.bin_id"
                        (change)="selectedBinChange($event)"
                        [ngClass]="{ 'has-value': this.workOrderService.workOrderData.bin_id }"
                        [disabled]="isBinSelectDisabled"
                      >
                        <option value="">{{ 'selectBinId' | translate }}</option>
                        @for (bin of binsArray; track bin.bin_id) {
                          <option [value]="bin.bin_id">{{ bin.bin_name }}</option>
                        }
                      </select>
                  </div>
                  }
                </div>
                }


                <!-- WORK ORDER TYPE SELECT INPUT -->
                <label class="label-spacer" for="clientName">{{ 'workOrderType' | translate }} <span class="requiredStar">*</span></label>
                <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon1"><i class="fas fa-clipboard-list"></i></span>
                    <select [(ngModel)]="this.workOrderService.workOrderData.work_order_type"
                            class="form-control"
                            name="work_order_type"
                            aria-label="Work Order Type"
                            aria-describedby="basic-addon1">
                        <option value="" disabled selected>{{ 'workOrderType' | translate }}</option>
                        @for (workOrderType of filteredWorkOrderTypes; track workOrderType.value) {
                        <option [value]="workOrderType.value">{{ getTranslatedLabel(workOrderType.label) | translate }}</option>
                        }
                    </select>
                </div>

                <!-- WORK ORDER STATUS SELECT INPUT -->
                <label class="label-spacer" for="clientName">{{ 'workOrderStatus' | translate }} <span class="requiredStar">*</span></label>
                <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon1"><i class="fas fa-circle-notch"></i></span>
                    <select [(ngModel)]="this.workOrderService.workOrderData.work_order_status"
                            class="form-control"
                            name="work_order_status"
                            aria-label="Work Order Status"
                            aria-describedby="basic-addon1"
                            [ngClass]="{'error-border': this.validationService.validationErrorArray[0] === 'clientInputError'}">
                        <option value="" disabled selected>{{ 'workOrderStatus' | translate }}</option>
                        @for (workOrderStatus of filteredWorkOrderStatus; track workOrderStatus.value) {
                        <option [value]="workOrderStatus.value">{{ getTranslatedLabel(workOrderStatus.label) | translate}}</option>
                        }
                    </select>
                </div>

                <!-- WORK ORDER DEADLINE DATE INPUT  -->
                <label class="label-spacer" for="deadline">{{ 'deadline' | translate }} <span class="requiredStar">*</span></label>
                <div class="input-group mb-3">
                    <span class="input-group-text" id="deadline-input"><i class="far fa-clock"></i></span>
                    <input
                        type="datetime-local"
                        class="form-control"
                        aria-label="Deadline"
                        aria-describedby="deadline-addon"
                        (input)="updateDeadline($event)"
                    />
                </div>

                <!-- DESCRIPTION TEXT INPUT  -->
                <label class="label-spacer" for="deadline">{{ 'workOrderDescription' | translate }}</label>
                <div class="input-group mb-3">
                    <textarea class="descriptionStyle bg-light"
                    id="descricao" name="descricao"
                    [(ngModel)]="descriptionData.description"
                    maxlength="600"
                    (touchstart)="startScroll($event)"
                    (touchmove)="scrollTextarea($event)"
                    (touchend)="stopScroll()"></textarea>
                    <!-- REMAINING CHARACTERS COUNTER -->
                    <div>{{ 'remainingCharacters' | translate }} {{ 600 - descriptionData.description.length }}</div>
                </div>

                <!-- Submit button -->
                <div class="form-group displayFlex">

                    <button
                      [ngClass]="theme.getThemeClass()"
                      type="button"
                      class="btn btn-primary btn-block btnCancel fixed-size"
                      (click)="cancelAction()"
                    >
                      {{ 'clientcreateFormBtnCancel' | translate }}
                    </button>

                    <button (click)="createBtn()" [ngClass]="theme.getThemeClass()" type="button" class="btn btn-primary btn-block btnCreate fixed-size">
                      @if (!isSaving) {
                      <span>
                        {{ "clientcreateFormBtnCreateClient" | translate }}
                      </span>
                      }
                      @if (isSaving) {
                      <div
                        class="spinner-border spinner-position spinner-button"
                        role="status"
                      >
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      }
                    </button>
                </div>
            </form>
        </article>
    </div>
</div>


